import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import { Spring } from 'react-spring';
import * as easings from 'd3-ease';
import styles from './home-connect.module.css';
import AddressHome from '../../address-home';
import Reveal from '../../reveal';

const HomeConnectContent = ({
  locationImages,
  browserDetect,
  mappedIndex,
  isInView,
}) => {
  const settings = {
    njImage: locationImages.new_jersey,
    nyImage: locationImages.new_york,
  };

  const renderLocation = (delay, locationName, image) => {
    const animationConfig = {
      delay: delay,
      duration: 800,
      easing: easings.easeCubicOut,
    };
    return (
      <Spring
        from={{ opacity: 0, transform: 'translateY(120px)' }}
        to={{
          opacity: isInView ? 1 : 0,
          transform: isInView ? 'translateY(0)' : 'translateY(120px)',
        }}
        config={animationConfig}
      >
        {animation => (
          <div className={styles.location} style={animation}>
            <div className={styles.address}>
              <AddressHome location={locationName} />
            </div>
            <div className={styles.bgCover} />
            <Img
              sizes={image.localFile.childImageSharp.sizes}
              backgroundColor={true}
              style={{ position: 'absolute' }}
              outerWrapperClassName={styles.bgImageWrapper}
              className={styles.bgImage}
            />
          </div>
        )}
      </Spring>
    );
  };

  const renderLocations = () => {
    return (
      <div className={styles.wrapper}>
        {renderLocation(200, 'new_jersey', settings.njImage)}
        {renderLocation(500, 'new_york', settings.nyImage)}
      </div>
    );
  };

  return (
    <div className={styles.locations}>
      <div className={styles.container}>{renderLocations()}</div>
    </div>
  );
};

const HomeConnect = props => {
  return (
    <Reveal>
      <HomeConnectContent {...props} />
    </Reveal>
  );
};

HomeConnect.propTypes = {
  locationImages: PropTypes.object,
  headerHeight: PropTypes.number,
  browserDetect: PropTypes.string,
};

export default HomeConnect;



// WEBPACK FOOTER //
// ./src/components/home/home-connect/index.js